import type React from 'react';
import { Box } from '@withjoy/joykit';
import type { DrawerAnimationStyle, UseDrawerAnimationParams } from './drawerAnimationBase';

const CSS_TRANSITION = 'transform 420ms cubic-bezier(0.2, 1, 0.4, 1)';

const AnimatedBoxCss: React.FC<React.ComponentProps<typeof Box>> = Box;

const getDrawerCssStyle = ({ isOpen, openPositionVh, closedHeightPx }: UseDrawerAnimationParams): DrawerAnimationStyle => ({
  transform: isOpen ? `translateY(${openPositionVh}vh)` : `translateY(calc(100vh - ${closedHeightPx}px))`,
  transition: CSS_TRANSITION,
  willChange: 'transform',
});

export const cssTransitionAnimation = {
  Wrapper: AnimatedBoxCss,
  useAnimation: getDrawerCssStyle,
} as const;
